<template>
  <div class="g-page__row">
    <h3>{{ $t('createEnvelope.prefilledFieldConfirmation.yourPrefillFields') }}</h3>
    <div class="merge-field-confirmation__items">
      <div
        v-for="(content, tag) in mergeFieldTags"
        :key="tag">
        <VGrid>
          <div slot="gridItem" type="7">
            <b>{{ tag }}</b>
          </div>
          <div slot="gridItem" type="5">
            <span v-if="content">{{ content }}</span>
            <i v-else>{{ $t('createEnvelope.prefilledFieldConfirmation.toBeFilledByParties') }}</i>
          </div>
        </VGrid>
      </div>
    </div>
  </div>
</template>

<script>
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'VMergeFieldConfirmation',
  components: {
    VGrid,
  },
  computed: {
    ...mapGetters({
      mergeFieldTags: 'envelopes/mergeFieldTags',
    }),
  },
};
</script>

<style scoped>
.merge-field-confirmation__items {
  background: #fff;
  border: 1px solid var(--color-border);
  padding: var(--spacing-base);
  border-radius: var(--spacing-xs);
  box-shadow: 0px 0px 5px -2px var(--color-border);
  position: relative;
}
</style>
